import requestAction from '../../utils/requestAction'
import RemoteTeacher, { RemoteTeacherInput } from '../../models/RemoteTeacher';

export const bulkUpsertTeachers = (records: (RemoteTeacher|RemoteTeacherInput)[]) =>
  requestAction('REMOTE_TEACHER_BULK_UPSERT')('remote-teachers/bulk', 'POST', { records })
